
      <!-- Default box -->
      <div class="card card-info"  [ngClass]="{'dark-bg' : isDark }">
        <div class="card-header">Fixed Asset</div> 
        <form [formGroup] ="itemForm" autocomplete="off" (ngSubmit)="saveButtonClick()" class="form-horizontal">
        <div class="card-body">  

        <div class="form-group row">
            <input  readonly formControlName="id"   type="hidden">
        </div>
  
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="assetCode" class="col-form-label">Asset Code</label>
                <div class="input-group">
                  <input type="text"  [ngClass]="{'dark-input-field' : isDark }" readonly formControlName="assetCode" class="form-control field-bg-color"  placeholder="Asset Code" [class.is-invalid]="formErrors.assetCode" (blur)="logValidationErrors()">
                </div>
                <span class="text-danger" *ngIf="formErrors.assetCode"><small>{{formErrors.assetCode}}</small> </span> 
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="assetName" class="col-form-label">Asset Name</label>
                <div class="input-group">
                  <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="assetName" class="form-control field-bg-color"  placeholder="Asset Name" [class.is-invalid]="formErrors.assetName" (blur)="logValidationErrors()">
                </div>
                <span class="text-danger" *ngIf="formErrors.assetName"><small>{{formErrors.assetName}}</small> </span> 
              </div>
            </div> 
            <div class="col-md-4">
              <div class="form-group">
                <label for="serialNo" class="col-form-label">Serial No</label>
                <div class="input-group">
                  <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="serialNo" class="form-control field-bg-color"  placeholder="Serial No" >
                </div>
              </div>
            </div> 

          </div>
  
          <div class="row"> 

            <div class="col-md-3">
              <div class="form-group">
                <label for="category" class="col-form-label">Category</label>
                <div class="input-group">   
                  <select  [ngClass]="{'dark-input-field' : isDark }" class="form-control field-bg-color" formControlName="category"  [class.is-invalid]="formErrors.category" (blur)="logValidationErrors()" >
                    <option [ngValue]="null">-Select-</option>
                    <option  *ngFor="let item of category" [value]="item.value">
                      {{item.value}}
                    </option>
                  </select>
                </div>
                <span class="text-danger" *ngIf="formErrors.category"><small>{{formErrors.category}}</small> </span>   
              </div>
            </div> 

             <div class="col-md-3">
              <div class="form-group">
                <label for="location" class="col-form-label">Location</label>
                <div class="input-group">  
                  <select  [ngClass]="{'dark-input-field' : isDark }" class="form-control field-bg-color" formControlName="location"  [class.is-invalid]="formErrors.location" (blur)="logValidationErrors()" >
                    <option [ngValue]="null">-Select-</option>
                    <option  *ngFor="let item of location" [value]="item.value">
                      {{item.value}}
                    </option>
                  </select>
                </div>
                <span class="text-danger" *ngIf="formErrors.location"><small>{{formErrors.location}}</small> </span>   
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="purchaseDate" class="col-form-label">Purchase Date</label>
                <div class="input-group">
                  <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig"  formControlName="purchaseDate" class="form-control field-bg-color"  placeholder="Purchase Date">
                </div>
              </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="cost" class="col-form-label">Cost</label>
              <div class="input-group">
                <input type="number" [ngClass]="{'dark-input-field' : isDark }" formControlName="cost" class="form-control field-bg-color"  placeholder="Cost">
              </div>
            </div>
          </div>

          </div>
  
          <div class="row"> 
            <div class="col-md-3">
              <div class="form-group">
                <label for="qty" class="col-form-label">Original Qty</label>
                <div class="input-group">
                  <input type="number"  [ngClass]="{'dark-input-field' : isDark }" formControlName="qty" class="form-control field-bg-color"  placeholder="Original Qty"  [class.is-invalid]="formErrors.qty" (blur)="logValidationErrors()">
                </div>  
                <span class="text-danger" *ngIf="formErrors.qty"><small>{{formErrors.qty}}</small> </span>                
              </div>
            </div> 

            <div class="col-md-3">
              <div class="form-group">
                <label for="usefulLife" class="col-form-label">Useful Life</label>
                <div class="input-group">
                  <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="usefulLife" class="form-control field-bg-color"  placeholder="Useful Life">
                </div>  
              </div>
            </div> 

            <div class="col-md-3">
              <div class="form-group">
                <label for="usefulQty" class="col-form-label">Useful Qty</label>
                <div class="input-group">
                  <input type="number"  [ngClass]="{'dark-input-field' : isDark }" formControlName="usefulQty" class="form-control field-bg-color"  placeholder="Useful Qty">
                </div>               
              </div>
            </div> 
   
          <div class="col-md-3">
            <div class="form-group">
              <label for="disposalQty" class="col-form-label">Disposal Qty</label>
              <div class="input-group">
                <input type="number"  [ngClass]="{'dark-input-field' : isDark }" formControlName="disposalQty" class="form-control field-bg-color"  placeholder="Disposal Qty">
              </div>               
            </div>
          </div> 
        </div>

        <div class="row"> 
          <div class="col-md-4">
            <div class="form-group">
              <label for="vendorName" class="col-form-label">Vendor Name</label>
              <div class="input-group">
                <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="vendorName" class="form-control field-bg-color"  placeholder="Vendor Name">
              </div>               
            </div>
          </div> 
          <div class="col-md-5">
            <div class="form-group">
              <label for="vendorAddress" class="col-form-label">Vendor Address</label>
              <div class="input-group">
                <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="vendorAddress" class="form-control field-bg-color"  placeholder="Vendor Address">
              </div>               
            </div>
          </div> 
          <div class="col-md-3">
            <div class="form-group">
              <label for="warrantyType" class="col-form-label">Warranty Type</label>
              <div class="input-group">  
                <select  [ngClass]="{'dark-input-field' : isDark }" class="form-control field-bg-color" formControlName="warrantyType" >
                  <option [ngValue]="null">-Select-</option>
                  <option  *ngFor="let item of WARRANTY_TYPE" [value]="item.value">
                    {{item.value}}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="row"> 
          <div class="col-md-3">
            <div class="form-group">
              <label for="warrantyPeriod" class="col-form-label">Warranty Period</label>
              <div class="input-group">
                <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="warrantyPeriod" class="form-control field-bg-color"  placeholder="Warranty Period">
              </div>               
            </div>
          </div> 
          <div class="col-md-3">
            <div class="form-group">
              <label for="warrantyExpiredOn" class="col-form-label">Warranty Expired On</label>
              <div class="input-group">
                <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig"  placement="top"  formControlName="warrantyExpiredOn" class="form-control field-bg-color"  placeholder="Warranty Expired On">
              </div>
            </div>
        </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="warrantyConditions" class="col-form-label">Warranty Conditions</label>
              <div class="input-group">
                <textarea type="text" [ngClass]="{'dark-input-field' : isDark }" rows="3"   formControlName="warrantyConditions" class="form-control field-bg-color"  placeholder="Warranty Conditions"></textarea>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="remarks" class="col-form-label">Remarks</label>
              <div class="input-group">
                <textarea type="text" [ngClass]="{'dark-input-field' : isDark }" rows="3"  formControlName="remarks" class="form-control field-bg-color"  placeholder="Remarks"></textarea>
              </div>
            </div>
          </div>
        </div>
      
        </div>
        <!-- /.card-body -->
        <div class="card-footer">
         <button type="button" (click)="newButtonClick()" class="btn btn-success ml-2">New</button>

          <button *ngIf="crud_access.create"  type="submit"  class="btn btn-info ml-2">
           <span *ngIf ="showProcessingIndicator" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Save
          </button>
  
          <button type="button" class="btn btn-primary ml-2" routerLink="../fixed-asset-list"><i class="fa fa-table p-1"></i>Fixed Asset List</button>
          <button  type="button"  *ngIf ="isShowAttachBtn" class="btn btn-primary ml-2" (click)="attachFileButtonClick()"><i class="fa fa-plus p-1"></i>Attach Files</button>        

        </div>
        <!-- /.card-footer-->
        </form>
      </div>

  

